import { FC, ReactNode, Fragment } from 'react';
import { Typography, Stack, SxProps, Theme } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import {
	ProductCustomizationIconSx,
	ProductCustomizationTextSX,
} from '@/components/blocks/ProductCustomization/style';

type ProductCustomizationProps = {
	show?: boolean;
	children?: ReactNode;
	sx?: SxProps<Theme>;
	sxIcon?: SxProps<Theme>;
	sxText?: SxProps<Theme>;
	sxAttributes?: SxProps<Theme>;
	extendedAttributes?: Array<{ key: string; value: string }>;
};

type ProductCustomizationAttributesProps = Pick<ProductCustomizationProps, 'extendedAttributes'> & {
	sx?: SxProps<Theme>;
};

const Attributes: FC<ProductCustomizationAttributesProps> = ({ extendedAttributes, sx }) => (
	<Fragment>
		<Typography>{':'}</Typography>
		<Stack direction="row" spacing={1} ml={1} sx={sx}>
			{extendedAttributes?.map(({ key, value }) => (
				<Typography key={key}>{value.replaceAll('_', ' ')}</Typography>
			))}
		</Stack>
	</Fragment>
);

export const ProductCustomization: FC<ProductCustomizationProps> = ({
	show,
	sx,
	sxText,
	sxIcon,
	sxAttributes,
	extendedAttributes,
}) => {
	if (!show) return null;
	return (
		<Stack direction="row" alignItems="center" sx={sx}>
			<AutoAwesome sx={sxIcon ?? ProductCustomizationIconSx} />
			<Typography sx={sxText ?? ProductCustomizationTextSX}>{'Personalizado'}</Typography>
			{extendedAttributes ? (
				<Attributes sx={sxAttributes} extendedAttributes={extendedAttributes} />
			) : null}
		</Stack>
	);
};
